/**
 * 推广返利管理 - 策略 API
 *
 * 对应后端: /admin/referral/policies
 */

import httpRequest from '@/utils/api'
import type { CommissionPolicy, PolicyCreateRequest } from '@/types/referral/policy'

enum API {
  policies = '/admin/referral/policies',
}

/** 获取所有策略 */
export const getPoliciesAPI = () => {
  return httpRequest.get<CommissionPolicy[]>({
    url: API.policies,
  })
}

/** 获取策略详情 */
export const getPolicyDetailAPI = (policyId: number) => {
  return httpRequest.get<CommissionPolicy>({
    url: `${API.policies}/${policyId}`,
  })
}

/** 创建策略 */
export const createPolicyAPI = (data: PolicyCreateRequest) => {
  return httpRequest.post<CommissionPolicy>({
    url: API.policies,
    data,
  })
}

/** 更新策略 */
export const updatePolicyAPI = (policyId: number, data: PolicyCreateRequest) => {
  return httpRequest.put<CommissionPolicy>({
    url: `${API.policies}/${policyId}`,
    data,
  })
}
